import React from "react"
import styles from "./quote.module.css"
import { SimpleLayout } from "./layout"

export default props => (
  <SimpleLayout
    style={{
      backgroundImage:
        "linear-gradient(0.25turn,rgba(99, 69, 148, 1),rgba(97, 169, 254, 1))",
    }}
  >
    <div className={styles.quote}>
      <p>
        <span className={styles.qmarks}>“</span>
        {props.quote}
        <span className={styles.qmarks}>”</span>
      </p>
      <h2>{props.quotee}</h2>
    </div>
  </SimpleLayout>
)
